const getOriginEvent = (origin, isItemLanding) => {
  const origins = {
    home: 'home_channel',
    homefood: 'shop_list_channel',
    shop_list_channel: 'shop_list_channel',
    shop_list: 'shop_list_channel',
  };

  const shopClickOrigin = origins[origin] || 'home_channel';

  const shopSponsoringPlacement = isItemLanding
    ? 'dish_navigation:list'
    : shopClickOrigin === 'shop_list_channel'
    ? 'shop_list:channel'
    : `${shopClickOrigin.split('_')[0]}:channel`;

  return {
    shopClickOrigin,
    shopSponsoringPlacement,
  };
};

export default getOriginEvent;
